(ns rothko.editor.document.paths
  (:require [com.rpl.specter :as sp]))

(defn caret?
  [{:keys [start-index start-offset end-index end-offset]}]
  (if (= [start-index start-offset]
         [end-index end-offset])
    sp/STAY
    sp/STOP))

(defn single-word-selection?
  [{:keys [start-index start-offset end-index end-offset]}]
  (if (and (= start-index end-index)
           (not= start-offset end-offset))
    sp/STAY
    sp/STOP))

(defn multi-word-selection?
  [{:keys [start-index start-offset end-index end-offset]}]
  (if (and (not= start-index end-index)
           (not= start-offset end-offset))
    sp/STAY
    sp/STOP))

(defn selection?
  [selection]
  (sp/if-path
   (single-word-selection? selection)
   (multi-word-selection? selection)))

(defn offset-to-last
  [offset]
  (sp/srange-dynamic (constantly offset) count))

(defn first-to-offset
  [offset]
  (sp/srange 0 offset))

(defn safe-nthpath
  [index path]
  (sp/if-path
   (sp/index-nav index)
   [(sp/nthpath index)
    path]))

(def WORD-LENGTH
  [:word
   (sp/view count)])

(defn word-length
  [index]
  [:script
   (safe-nthpath index WORD-LENGTH)])

(defn collect-surrounds
  [{:keys [start-index start-offset end-index end-offset] :as selection}]
  (sp/collect
   :script
   (sp/multi-path
    [(sp/nthpath start-index)
     :word
     (first-to-offset start-offset)]
    [(sp/nthpath end-index)
     :word
     (offset-to-last end-offset)])))

(defn selection-to-next
  [offset]
  [:selection
   (sp/multi-path
    [:start-index
     (sp/terminal inc)]
    [:start-offset
     (sp/terminal-val offset)]
    [:end-index
     (sp/terminal inc)]
    [:end-offset
     (sp/terminal-val offset)])])

(defn handle-empty-document
  [path index else]
  (sp/if-path
   [:script (sp/index-nav index)]
   path
   else))

(defn end?
  [index]
  [:script
   (sp/index-nav (inc index))])

(defn if-end?
  [index then-path & else-path]
  (sp/if-path
   (end? index)
   then-path
   (first else-path)))

(defn if-only
  [start-index end-index types]
  (sp/not-selected?
   [:script
    (sp/srange start-index (inc end-index))
    sp/ALL
    :type
    (fn [value]
      (not (contains? types value)))]))

(defn end-of-script?
  [index]
  (sp/if-path
   [:script
    (sp/index-nav (inc index))]
   sp/STOP
   sp/STAY))

(defn start-of-script?
  [index]
  (if (= 0 index)
    sp/STAY
    sp/STOP))
